import React, { useState } from "react";
import { Button, Tab, Select, Input, Icon } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import {
  LiveClassForm,
  ListLiveClass,
} from "../../../components/Admin/LiveClass";
import "./LiveClass.scss";

export function LiveClass() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [status, setStatus] = useState("");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  
  // Estados para los inputs (valores no aplicados)
  const [statusInput, setStatusInput] = useState("");
  const [searchInput, setSearchInput] = useState("");

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  const handleItemsPerPageChange = (newLimit) => {
    setLimit(newLimit);
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  const handleStatusInputChange = (value) => {
    setStatusInput(value);
  };

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleSearch = () => {
    setStatus(statusInput);
    setSearch(searchInput);
    setCurrentPage(1);
  };

  const handleClearFilters = () => {
    setStatusInput("");
    setSearchInput("");
    setStatus("");
    setSearch("");
    setCurrentPage(1);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const statusOptions = [
    { key: "", value: "", text: "Selecciona un estado" },
    { key: "scheduled", value: "scheduled", text: "Programadas" },
    { key: "active", value: "active", text: "En progreso" },
    { key: "ended", value: "ended", text: "Finalizadas" },
    { key: "cancelled", value: "cancelled", text: "Canceladas" },
  ];

  const panes = [
    {
      render: () => (
        <div className="live-classes-page__filters">
          <Select
            className="live-classes-page__filter-select edunova-select"
            options={statusOptions}
            value={statusInput}
            clearable
            onChange={(e, { value }) => handleStatusInputChange(value)}
            placeholder="Selecciona un estado"
          />
          <Input
            icon="search"
            iconPosition="left"
            type="text"
            placeholder="Buscar por nombre o descripción..."
            value={searchInput}
            onChange={handleSearchInputChange}
            onKeyPress={handleKeyPress}
          />
          <Button primary onClick={handleSearch}>
            <Icon name="search" />
            Buscar
          </Button>
          <Button color="grey" onClick={handleClearFilters}>
            <Icon name="eraser" />
            Limpiar filtros
          </Button>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="live-classes-page">
        <Button
          className="live-classes-page__add"
          primary
          onClick={onOpenCloseModal}
        >
          Nueva clase en vivo
        </Button>
        <Tab menu={{ secondary: true }} panes={panes} />
        <ListLiveClass
          reload={reload}
          onReload={onReload}
          status={status}
          search={search}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          limit={limit}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
      </div>
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={"Crear clase en vivo"}
      >
        <LiveClassForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </>
  );
}
